export default [
  {
    path: '/h5/room_task_record',
    component: () => import('./Page.vue'),
    meta: {
      title: '房间任务积分记录',
    },
  },
]
